import script from "./BaseForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseForm.vue?vue&type=script&setup=true&lang=ts"

import "./BaseForm.vue?vue&type=style&index=0&id=916b4d04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-916b4d04"]])

export default __exports__